<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetWcagSettings'
});

interface FormSettings
{
    settings: any;
}

const props = defineProps<{
    modelValue: any;
}>();
const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const module = ref('articles');
const defaults = ref<any>({
    page: null
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Strona deklaracja dostępności]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')">
        <EditoPageSelector
            v-model="form.settings.page"
            :module="module"
            :website-id="form.websiteId"
            :locale="form.locale"
            label=""
            :website="false"
            :preview="false"
            class="mb-0"
        />
    </IdeoFormGroup>
</template>
